<h2>Impersonation</h2>
@if (loading) {
  <div class="loading-spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <kendo-grid class="grid-size" [kendoGridBinding]="gridView" [sortable]="true" [sort]="sort" [pageSize]="20" scrollable="none" [pageable]="true" [resizable]="true" [reorderable]="true" [navigable]="['table', 'pager']">
    <ng-template kendoGridToolbarTemplate>
      <!-- Search -->
      <kendo-textbox [style.width.px]="240" placeholder="Search User" (valueChange)="onFilter($event)"></kendo-textbox>
      <kendo-grid-spacer></kendo-grid-spacer>
    </ng-template>
    <!-- Columns -->
    <kendo-grid-column field="CompanyName" title="Company"></kendo-grid-column>
    <kendo-grid-column field="UserName" title="User Name"></kendo-grid-column>
    <kendo-grid-column field="FirstName" title="First Name"></kendo-grid-column>
    <kendo-grid-column field="LastName" title="Last Name"></kendo-grid-column>
    <kendo-grid-column title="" [width]="120">
      <ng-template kendoGridCellTemplate let-dataItem>
        <!-- Impersonate User -->
        <button class="disabled-color" type="button" mat-icon-button [matTooltip]="'Sign in as ' + dataItem.UserName" (click)="impersonationUser(dataItem.UserName)">
          <mat-icon class="material-icons-outlined">group_search</mat-icon>
        </button>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
}
